import { __assign, __rest } from "tslib";
import React, { useCallback, useMemo } from 'react';
import { DateRange } from 'react-date-range';
import { formatDate } from '../../helpers/utils';
import DateComponentWrapper from './DateComponentWrapper';
var DateRangePickerComponent = function (_a) {
    var title = _a.title, onChange = _a.onChange, dateDisplayFormat = _a.dateDisplayFormat, defaultValue = _a.defaultValue, value = _a.value, onUpdateValue = _a.onUpdateValue, _b = _a.dateRangePickerProps, _c = _b === void 0 ? {} : _b, dateRangePickerOnChange = _c.onChange, dateRangePickerProps = __rest(_c, ["onChange"]), props = __rest(_a, ["title", "onChange", "dateDisplayFormat", "defaultValue", "value", "onUpdateValue", "dateRangePickerProps"]);
    var updateRange = function (range) {
        var newRange = [range[0].startDate, range[0].endDate];
        onChange && onChange(newRange);
        onUpdateValue && onUpdateValue(newRange);
        dateRangePickerOnChange === null || dateRangePickerOnChange === void 0 ? void 0 : dateRangePickerOnChange(range);
    };
    var date = useCallback(function (pos) {
        if (value) {
            return formatDate(value[pos]);
        }
        else {
            if (defaultValue) {
                return formatDate(defaultValue[pos]);
            }
        }
        return null;
    }, [value, defaultValue]);
    var dateValue = useMemo(function () {
        if (date(0) !== null) {
            if (date(1) !== null) {
                return "".concat(date(0), " | ").concat(date(1));
            }
            else {
                return "".concat(date(0));
            }
        }
        else {
            return '-';
        }
    }, [date]);
    return (React.createElement(DateComponentWrapper, __assign({ value: dateValue }, { title: title }, props),
        React.createElement(DateRange, __assign({ editableDateInputs: true, onChange: function (item) { return updateRange(item); }, moveRangeOnFirstSelection: true, ranges: [
                {
                    startDate: (value && value[0]) || new Date(),
                    endDate: (value && value[1]) || new Date(),
                    key: 'selection'
                },
            ], rangeColors: ['primary', 'primary'] }, { dateDisplayFormat: dateDisplayFormat }, dateRangePickerProps))));
};
export default DateRangePickerComponent;
//# sourceMappingURL=DateRangePickerComponent.js.map